import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const departmentPerformanceService = {
  

  getDepartmentList: async () => {
    try {
      const response = await axiosInstance.get(API.department.getList);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDepartmentPerformance: async(departmentId) => {
    try{
        const response = await axiosInstance.get(API.reports.getDepartmentPerfomance(departmentId));
        return response.data;
    } catch (error){
        throw error;
    }
  }
};
